module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "pagination__bottom"
  }, [_c('a', {
    staticClass: "pagination__bottom--prev",
    attrs: {
      "href": "",
      "disabled": _vm.isFirstPage() || _vm.loading.state,
      "title": _vm.$lang.pagination.prev_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPreviousPage()
      }
    }
  }, [_c('i', {
    staticClass: "onp-chevron-left pagination__bottom--prev-arrow",
    attrs: {
      "data-v-704e50d2": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$lang.pagination.prev))])]), _vm._v(" "), _c('a', {
    staticClass: "pagination__bottom--next",
    attrs: {
      "href": "",
      "disabled": _vm.isLastPage() || _vm.loading.state,
      "title": _vm.$lang.pagination.next_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setNextPage()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.pagination.next))]), _vm._v(" "), _c('i', {
    staticClass: "onp-chevron-right pagination__bottom--next-arrow",
    attrs: {
      "data-v-704e50d2": "",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.appIsRunning) ? _c('ul', {
    staticClass: "pagination__bottom--list"
  }, _vm._l((_vm.totalPagesNum), function(n) {
    return _c('li', [(_vm.isDisplayed(n)) ? _c('a', {
      staticClass: "pagination__bottom--list-link",
      class: [{
        'is-current': _vm.currentPage == n
      }],
      attrs: {
        "href": "",
        "disabled": _vm.loading.state,
        "title": n
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setActivePage(n)
        }
      }
    }, [_vm._v(" " + _vm._s(n) + " ")]) : (_vm.isDisplayedEllipsis(n)) ? _c('span', {
      staticClass: "pagination__bottom--list-span"
    }, [_vm._v("…")]) : _vm._e()])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-222507bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/Pagination.vue
// module id = 332
// module chunks = 1